import { EnFlag, FlagIcon, RuFlag, UzFlag } from './flags'
import { Lang } from '@/types/utility.types'

export interface LangOption {
  value: Lang
  label: string
  flag: FlagIcon
}

export const LANGS: LangOption[] = [
  { value: 'uz', label: 'Oʻz', flag: UzFlag },
  { value: 'ru', label: 'Ru', flag: RuFlag },
  { value: 'en', label: 'En', flag: EnFlag },
]
